import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=7da39718&scoped=true"
import script from "./SideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=7da39718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da39718",
  null
  
)

export default component.exports